import { createRouter, createWebHistory } from '@ionic/vue-router';
import { useAuthStore} from '@/stores/auth.store'
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import LoginForm from '@/views/LoginForm.vue'
import RegisterForm from '@/views/RegisterForm.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'
import SupportForm from '@/views/SupportForm.vue'
import DeleteForm from '@/views/DeleteForm.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import UnsubscribeForm from '@/views/UnsubscribeForm.vue'

import ProfileView from '@/views/ProfileView.vue'
import BillingView from '@/views/BillingView.vue'
import LanguageConfig from '@/views/LanguageConfig.vue'
import Tab2Page from '@/views/Tab2Page.vue'

import HomeView from '@/views/HomeView.vue'
import HelpView from '@/views/HelpView.vue'
import TermsView from '@/views/TermsView.vue'
import PrivacyView from '@/views/PrivacyView.vue'

import { fetchWrapper } from '@/helpers/fetch-wrapper'
import { isApp } from '@/helpers/utils.js'

import CurriculumExploreView from '@/views/CurriculumExploreView.vue'


var routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'HomeView',
    meta: { title: 'Lingo.ing Home' },
    component: HomeView
  },
  {
    path: '/help',
    name: 'HelpView',
    meta: { title: 'Lingo.ing Help' },
    component: HelpView
  },
  // sometimes the PWA service worker will intercept /admin/, but this makes it hit the django server instead
  {
    path: '/admin/*',
    beforeEnter() {
      window.location.href = '/admin/'
    }
  },
  {
    path: '/debug-capacitor-plugin',
    component: () => import('@/views/debug/DebugCapacitorPlugin.vue')
  },
  {
    path: '/debug-links',
    component: () => import('@/views/debug/DebugLinks.vue')
  },
  {
    path: '/debug-audio',
    component: () => import('@/views/debug/DebugAudio.vue')
  },
  {
    path: '/debug-audio2',
    component: () => import('@/views/debug/DebugAudio2.vue')
  },
  {
    path: '/debug-audio3',
    component: () => import('@/views/debug/DebugAudio3.vue')
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    meta: { title: 'Lingo.ing Terms Of Use' },
    component: TermsView
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: { title: 'Lingo.ing - Privacy Policy' },
    component: PrivacyView
  },
  {
    path: '/privacy-policy/',
    name: 'PrivacyPolicy',
    meta: { title: 'Lingo.ing - Privacy Policy' },
    component: PrivacyView
  },
  {
    path: '/try/:topicID',
    name: 'CurriculumLandingTopicFlashcards',
    meta: { title: 'Try Lingo.ing - Interactive Language Learning' },
    component: () => import('@/views/CurriculumLandingTopicFlashcards.vue')
  },
  {
    path: '/login',
    name: 'LoginForm',
    component: LoginForm
  },
  {
    path: '/forgot-password/',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password/:validation_user/:validation_token/',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/register/:validation_user/:validation_token/',
    name: 'EmailValidateLegacy',
    component: VerifyEmail
  },
  {
    path: '/register',
    name: 'RegisterForm',
    component: RegisterForm
  },
  {
    path: '/support',
    name: 'SupportForm',
    component: SupportForm
  },
  {
    path: '/data-deletion/',
    name: 'DeleteForm',
    component: DeleteForm
  },
  {
    path: '/unsubscribe-form/',
    name: 'UnsubscribeForm',
    component: UnsubscribeForm
  },
  {
    path: '/booga',
    component: TabsPage,
    children: [
      {
        path: '/debug-ad',
        components: {
          default: Tab2Page,
          sub: import('@/views/debug/DebugAd.vue')
        },
      },
      {
        path: '/debug-internal-footer',
        components: {
          default: Tab2Page,
          sub: import('@/views/debug/DebugInternalFooter.vue')
        },
      },
      {
        path: '/curriculum/explore/',
        name: 'CurriculumExploreView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: CurriculumExploreView
        },
      },
      {
        path: '/curriculum/progress/',
        name: 'UnitProgressView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/UnitProgressView.vue')
        },
      },
      {
        path: '/curriculum/game/:topicID/',
        name: 'GameView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/GameView.vue')
        },
      },
      {
        path: '/curriculum/interests/',
        name: 'CurriculumUserInterestsView',
        meta: { title: 'Interests - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/CurriculumUserInterestsView.vue')
        },
      },
      {
        path: '/curriculum/topic/:topicID/',
        name: 'CurriculumTopicView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/CurriculumTopicView.vue')
        },
      },
      {
        path: '/curriculum/category/:categoryID/',
        name: 'CurriculumCategoryView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/CurriculumCategoryView.vue')
        },
      },
      {
        path: '/curriculum/game/:conceptID/multiple-choice/:direction/',
        name: 'CurriculumGameMultipleChoiceView',
        meta: { title: 'Debug Multiple Choice' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumGameMultipleChoiceView.vue')
        },
      },
{
        path: '/curriculum/game/:conceptID/audio-choice/',
        name: 'CurriculumAudioChoiceView',
        meta: { title: 'Debug Audio Choice' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumAudioChoiceView.vue')
        },
      },
      {
        path: '/curriculum/unit/:unitID/',
        name: 'CurriculumUnitView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/CurriculumUnitView.vue')
        },
      },
      {
        path: '/curriculum/concept/:conceptID/',
        name: 'CurriculumConceptView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/CurriculumConceptView.vue')
        },
      },
      {
        path: '/curriculum/game/:topicID/matching/',
        name: 'CurriculumMatchingGameView',
        meta: { title: 'Curriculum - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumMatchingGameView.vue')
        },
      },
      {
        path: '/dashboard/',
        name: 'Dashboard',
        meta: { title: 'Dashboard - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/DashboardView.vue')
        },
      },
      {
        path: '/cards/game/',
        name: 'FlashcardGameView',
        meta: { title: 'Flashcards - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/FlashcardGameView.vue')
        }
      },
      {
        path: '/cards/incorrect/',
        name: 'IncorrectFlashcards',
        meta: { title: 'Incorrect Flashcards - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/IncorrectFlashcardsView.vue')
        },
      },
      {
        path: '/vocab/add/',
        name: 'AddVocab',
        meta: { title: 'Add Vocab - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/VocabAdd.vue')
        },
      },
      {
        path: '/vocab/recent/',
        name: 'RecentVocabEntry',
        meta: { title: 'Cards - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/RecentVocabList.vue')
        },
      },
      {
        path: '/vocab/',
        name: 'VocabEntry',
        meta: { title: 'Cards - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/VocabList.vue')
        },
      },
      {
        path: '/vocab/edit/:id/',
        name: 'EditVocab',
        meta: { title: 'Edit Vocab - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/EditVocab.vue')
        },
      },
      {
        path: '/profile/',
        name: 'ProfileView',
        meta: { title: 'Profile - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: ProfileView
        },
      },
      {
        path: '/profile/change-password/',
        name: 'ChangePassword',
        meta: { title: 'Profile - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/ChangePassword.vue')
        },
      },
      {
        path: '/profile/language/:languageID/',
        name: 'LanguageConfig',
        meta: { title: 'Profile - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: LanguageConfig
        },
      },
      {
        path: '/billing/',
        name: 'BillingView',
        meta: { title: 'Billing - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: BillingView
        },
      },
      {
        path: '/chat/',
        name: 'ChatCategories',
        meta: { title: 'Categories - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/ChatCategories.vue')
        },
      },
      {
        path: '/chat/templates/:categoryID/',
        name: 'ChatTemplates',
        components: {
          default: Tab2Page,
          sub: () => import('@/views/ChatTemplates.vue')
        },
      },
      {
        path: '/chat/history/',
        name: 'ChatHistory',
        meta: { title: 'Chat History - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/ChatHistory.vue')
        }
      },
      {
        path: '/article/list/',
        name: 'ArticleList',
        meta: { title: 'Articles - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/ArticleList.vue')
        },
      },
      {
        path: '/news/',
        name: 'NewsArticleList',
        meta: { title: 'News Articles - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/NewsArticleList.vue')
        },
      },
      {
        path: '/news/:articleId',
        name: 'NewsArticleDetail',
        meta: { title: 'News Article - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/NewsArticleDetail.vue')
        },
      },
      {
        path: '/achievements/',
        name: 'Achievements',
        meta: { title: 'Achievements - Lingo.ing' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/AchievementsView.vue') 
        }
      },
      {
        path: '/feedback',
        name: 'FeedbackForm',
        meta: { title: 'Feedback' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/FeedbackForm.vue')
        }
      },
      {
        path: '/curriculum/game/:conceptID/free-translation/:gameType/:direction/',
        name: 'CurriculumGameFreeTranslationView',
        meta: { title: 'Debug Free Translation Game' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumGameFreeTranslationView.vue')
        },
      },
      {
        path: '/curriculum/game/:conceptID/introduce-concept/',
        name: 'CurriculumGameIntroduceConceptView',
        meta: { title: 'Debug Introduce Concept' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumGameIntroduceConceptView.vue')
        },
      },
      {
        path: '/curriculum/game/:topicID/sentence-builder-audio/',
        name: 'CurriculumGameSentenceBuilderAudioView',
        meta: { title: 'Debug Sentence Builder Audio Game' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumSentenceBuilderAudioView.vue')
        },
      },
      {
        path: '/curriculum/game/:topicID/sentence-builder/',
        name: 'CurriculumGameSentenceBuilderView',
        meta: { title: 'Debug Sentence Builder Game' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumGameSentenceBuilderView.vue')
        },
      },
      {
        path: '/curriculum/game/:topicID/dialogue/',
        name: 'CurriculumDialogueGameView',
        meta: { title: 'Debug Dialogue Game' },
        components: {
          default: Tab2Page,
          sub: () => import('@/views/debug/CurriculumDialogueGameView.vue')
        },
      },
    ]
  },
]

if (isApp) {
  //iterate routes and remove entry for /
  routes = routes.filter(route => route.path !== '/')
  routes.push({
    path: '/',
    name: 'RegisterForm',
    component: RegisterForm
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

function match_path(path: string, condition: Object) {
  if (typeof condition === 'string') {
    return path === condition
  }
  return condition.test(path)
}

router.beforeEach(async (to) => {
  // redirect to login page if not logged in
  const publicPages = [
    '/',
    '/login',
    '/register/',
    '/support/',
    '/forgot-password/',
    '/terms-of-use',
    '/privacy-policy',
    '/privacy-policy/',
    '/help',
    '/unsubscribe-form',
    '/unsubscribe-form/',
    '/debug-ad/',
    new RegExp("^/try/[0-9]+/?$"),
    new RegExp("^/register/[0-9]+/[a-z]+/?$"),
    new RegExp("^/email-validate/[0-9]+/[a-z]+/?$"),
    new RegExp("^/reset-password/[0-9]+/[a-z]+/?$"),
  ]
  const paidPages = [
    new RegExp("^/articles"),
    new RegExp("^/chat/"),
    new RegExp("^/cards"),
    new RegExp("^/course"),
    new RegExp("^/vocab"),
    new RegExp("^/curriculum"),
  ]
  var authRequired = true
  var paymentRequired = false
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
  else {
    document.title = 'Lingo.ing'
  }
  // iterate throguh public pages, if the list item is a string, then look for an exact match.
  // if the list item is a regex, then test the regex against the path
  // if either match as positive, set the authRequired value to false
  for (var i = 0; i < publicPages.length; i++) {
    if (match_path(to.path, publicPages[i])) {
      authRequired = false
    }
  }
  for (var i = 0; i < paidPages.length; i++) {
    if (match_path(to.path, paidPages[i])) {
      paymentRequired = true
    }
  }
  console.log('router debug', to.path, authRequired, paymentRequired)

  var auth = useAuthStore()

  if (to.path === '/login') {
    auth.returnUrl = undefined
  }
  if (authRequired && !auth.user) {
    // auth.returnUrl = to.fullPath AE this might be causing fussiness with broekn auth
    // i think it may be over-written several times during a 401/403 chain
    auth.returnUrl = undefined
    console.log("authRequired, no user, redirecting to login")
    return '/login'
  }
  if (authRequired) {
    try {
      await auth.getUserDetails(true)
    } catch(error) {
      console.log('error on userDetails', error)
      return '/login'
    }
    if (paymentRequired && auth.details.billing_locked) {
      return '/billing'
    }
  }
})



export default router
